<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Solicitação de Desligamento' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <form class="sample-form validations-form" [formGroup]="validations_form"
    (ngSubmit)="onSubmit(validations_form.value)">
    <div class="gradient-extendido"></div>

    <div>
      <ion-card-content>
        <ion-item>
          <ion-label position="stacked">{{'Ocorrência' | translate}}
            <span class="danger">*</span>
          </ion-label>

          <ion-select interface="action-sheet" cancelText="{{'Cancelar' | translate}}"
            okText="{{'Confirmar' | translate}}" placeholder="{{'Ocorrência' | translate}}"
            formControlName="ocorrencias">
            <ion-select-option *ngFor="let v of ocorrencias" [value]="v.nome">{{v.nome}}</ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item class="switcher-item">
          <ion-label position="stacked">{{'Motivo do Desligamento' | translate}}
            <span class="danger">*</span>
          </ion-label>

          <ion-textarea rows="4" type="text" formControlName="anotacao"></ion-textarea>
        </ion-item>

        <ion-grid>
          <ion-row class="ion-justify-content-center">
            <ion-col size="5">
              <div>
                <ion-button
                  class="btn-success"
                  expand="block"
                  type="submit"
                  [disabled]="!validations_form.valid"
                >{{'Salvar' | translate}}</ion-button>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card-content>
    </div>

  </form>
</ion-content>